import './elevenlabs/patchSdk';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { ConversationProvider } from '@elevenlabs/react';
import './index.css';
import App from './App';
import { createClientTools } from './elevenlabs/clientTools';

const root = ReactDOM.createRoot(document.getElementById('root'));
// StrictMode disabled: it double-mounts WebRTC and causes immediate "agent disconnected"
root.render(
  <ConversationProvider clientTools={createClientTools()}>
    <App />
  </ConversationProvider>
);
